import { Add, Remove } from "@mui/icons-material";
import { Box, Button, Divider, Grid, List, Typography } from "@mui/material";
import { colors, alphaVar } from "../../../../../../ui/colors";
import { useScopeOfWork } from "../../context/ScopeOfWorkContext";
import { useAreaActions } from "./hooks/useAreaActions";
import { TaskSwitch } from "./Tasks/TaskSwitch";

//AREA MODAL JOBS
export const AreaModal = ({ areaUid }: { areaUid: string }) => {
  const { state } = useScopeOfWork();
  const { changeQuantity, toggleTask } = useAreaActions();

  const current = (state.areas ?? []).find((a: any) => a.uid === areaUid) ?? (state.otherAreas ?? []).find((a: any) => a.uid === areaUid);

  if (!current) {
    return (
      <Box p={3}>
        <Typography>No area data found.</Typography>
      </Box>
    );
  }

  const quantity = Number(current?.squareFootages?.[0]?.quantity ?? 0);
  const tasks = Array.isArray(current.tasks) ? current.tasks : [];

  const safeDescription = current?.description?.split?.("@")?.[0] || "No description available for this area.";

  return (
    <Box sx={{ width: "100%", height: "100%", borderRadius: 3, p: 3, boxSizing: "border-box", display: "flex", flexDirection: "column" }}>
      <Typography variant="h5" fontWeight={700} color={colors.gray[800]} textAlign="center" sx={{ mb: 3 }}>
        {current.name}
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <Box
            component="img"
            src={current?.imageUrl}
            alt={current.name}
            sx={{ width: "100%", height: 300, objectFit: "contain", backgroundColor: "var(--fx-surface-base, #FFFFFF)" }}
          />
        </Grid>

        {/* <Grid item xs={12} md={4}> */}
        {/* <Typography variant="body2" color={colors.gray[600]} sx={{ lineHeight: 1.6 }}>
            {safeDescription}
          </Typography> */}
        {/* </Grid> */}

        <Grid item xs={12} display="flex" alignItems="center" justifyContent="center" mt={2}>
          <Button
            onClick={() => quantity > 0 && changeQuantity(current.uid, -1)}
            disabled={quantity === 0}
            sx={{
              minWidth: 50,
              height: 50,
              borderRadius: "50%",
              color: quantity === 0 ? colors.gray[300] : colors.orange.base,
              border: `1px solid ${alphaVar(colors.orange.base, 0.3)}`,
              "&:hover": { backgroundColor: alphaVar(colors.orange[100], 0.1) },
            }}
          >
            <Remove />
          </Button>

          <Typography variant="h5" fontWeight={700} sx={{ width: 60, textAlign: "center", color: colors.gray[700], mx: 2 }}>
            {quantity}
          </Typography>

          <Button
            onClick={() => changeQuantity(current.uid, +1)}
            sx={{
              minWidth: 50,
              height: 50,
              borderRadius: "50%",
              color: colors.orange.base,
              border: `1px solid ${alphaVar(colors.orange.base, 0.3)}`,
              "&:hover": { backgroundColor: alphaVar(colors.orange[100], 0.1) },
            }}
          >
            <Add />
          </Button>
        </Grid>

        <Grid item xs={12} mt={2}>
          <Divider sx={{ mb: 1 }} />
          <Typography variant="subtitle1" fontWeight={600} color={colors.gray[700]} sx={{ mb: 1 }}>
            Tasks included:
          </Typography>

          <List dense sx={{ height: "100%", width: "100%" }}>
            {tasks?.map((task: any) => {
              const tid = String(task.uid ?? task.id);
              const checked = !!task.active;

              return (
                <TaskSwitch
                  key={tid}
                  task={task}
                  checked={checked}
                  disabled={quantity === 0}
                  quantity={quantity}
                  areaUid={current.uid}
                  onToggle={() => toggleTask(current.uid, tid)}
                />
              );
            })}
          </List>
        </Grid>
      </Grid>
    </Box>
  );
};
